import React from "react";
import "./AppCard.scss";

/**
 * AppCard — Reusable card component matching UX_DESIGNS card.tsx.
 *
 * Exports: AppCard, AppCardHeader, AppCardTitle, AppCardContent, AppCardFooter
 *
 * All components accept className and spread remaining props.
 */

const AppCard = React.forwardRef(({ className = "", children, hover = false, ...props }, ref) => (
  <div
    ref={ref}
    className={`app-card ${hover ? "app-card--hover" : ""} ${className}`}
    {...props}
  >
    {children}
  </div>
));
AppCard.displayName = "AppCard";

const AppCardHeader = React.forwardRef(({ className = "", children, ...props }, ref) => (
  <div ref={ref} className={`app-card__header ${className}`} {...props}>
    {children}
  </div>
));
AppCardHeader.displayName = "AppCardHeader";

const AppCardTitle = React.forwardRef(({ className = "", children, as: Tag = "h3", ...props }, ref) => (
  <Tag ref={ref} className={`app-card__title ${className}`} {...props}>
    {children}
  </Tag>
));
AppCardTitle.displayName = "AppCardTitle";

const AppCardContent = React.forwardRef(({ className = "", children, ...props }, ref) => (
  <div ref={ref} className={`app-card__content ${className}`} {...props}>
    {children}
  </div>
));
AppCardContent.displayName = "AppCardContent";

const AppCardFooter = React.forwardRef(({ className = "", children, ...props }, ref) => (
  <div ref={ref} className={`app-card__footer ${className}`} {...props}>
    {children}
  </div>
));
AppCardFooter.displayName = "AppCardFooter";

export { AppCard, AppCardHeader, AppCardTitle, AppCardContent, AppCardFooter };
export default AppCard;
